var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type ==='line')?_c('line-chart',{attrs:{"translations":_vm.translations,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type !=='line')?_c('chart',{ref:"chart",staticClass:"doughnut",attrs:{"legend":"Legend","data":_vm.data,"type":_vm.type,"translations":_vm.translations}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }